/* eslint-disable block-scoped-var */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

import "phaser";
export class TextManager {
    constructor() {

    }
    AddTextInScene(scene, x, y, text, fontsize, fillDegree) {
        return scene.add.text(
            x,
            y,
            text, {
                fontSize: fontsize,
                fill: fillDegree,
            });
    }
    setTextOnScene(obj, value) {
        return obj.setText(value)

    }





}